/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2024-03-05 17:01:01
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2024-03-21 15:45:15
 * FilePath     :\AV-COM-user-backend\src\router\enterprise.js
 * RevisionHistory:
 */
import i18n from "@/lang/index";
export const enterpriseRouter = {
    path: "/",
    component: () => import("@/layout/BasisLayout"), //路由懒加载
    name: "home",
    redirect: "/userinfo",
    children: [
        {
            path: "/userinfo",
            name: "userinfo",
            component: () => import("@/views/userInfo/index"),
            meta: {
                name: i18n.t("menu.account"),
                icon: "info",
                menue: true,
                menuTxt: i18n.t("menu.account"),
            },
        },
        {
            path: "/device",
            name: "PersonalDevice",
            component: () => import("@/views/device/index"),
            meta: {
                name: i18n.t("menu.personalDevice"),
                icon: "personal",
                menue: true,
                menuTxt: i18n.t("menu.personalDevice"),
            },
        },
        // {
        //     name: "team",
        //     path: ":companyName/team/",
        //     // redirect: "device",
        //     component: RouteView,
        //     meta: {
        //         name: "{team}",
        //         menue: true,
        //     },
        //     children: [
        //         {
        //             path: "/:companyName/team/information",
        //             name: "TeamMember",
        //             component: () => import("@/views/team/information"),
        //             meta: {
        //                 name: i18n.t("menu.teamInformation"),
        //                 isEnterprise: true,
        //                 icon: "team",
        //                 menue: true,
        //             },
        //         },
        //         {
        //             name: "device",
        //             path: "/Gdevice",
        //             redirect: "/:companyName/team/device",
        //             component: RouteView,
        //             meta: {
        //                 name: "设备管理",
        //                 icon: "device",
        //                 menue: true,
        //             },
        //             children: [
        //                 {
        //                     path: "/:companyName/team/device",
        //                     name: "deviceList",
        //                     component: () =>
        //                         import("@/views/team/device/deviceList"),
        //                     meta: {
        //                         name: i18n.t("menu.devMagList"),
        //                         isEnterprise: true,
        //                         type: "device",
        //                         role: ["manage", "view"],
        //                     },
        //                 },
        //                 {
        //                     path: "deploy",
        //                     name: "deviceDeploy",
        //                     component: () =>
        //                         import("@/views/team/device/deploy"),
        //                     meta: {
        //                         name: i18n.t("menu.devMagDeploy"),
        //                         isEnterprise: true,
        //                         type: "device",
        //                         role: ["manage", "view", "not"],
        //                     },
        //                 },
        //                 {
        //                     path: "apply",
        //                     name: "apply",
        //                     component: () =>
        //                         import(
        //                             "@/views/team/device/deploy/DeployTable.vue"
        //                         ),
        //                     meta: {
        //                         name: i18n.t("menu.devMagApply"),
        //                         isEnterprise: true,
        //                         type: "device",
        //                         role: ["manage", "view"],
        //                     },
        //                 },
        //             ],
        //         },
        //         {
        //             name: "user",
        //             path: ":companyName/",
        //             redirect: ":companyName/team/member",
        //             meta: {
        //                 name: i18n.t("menu.memberManagement"),
        //                 role: ["manage", "view"],
        //                 type: "user",
        //                 icon: "users",
        //             },
        //             children: [
        //                 {
        //                     path: ":companyName/team/member",
        //                     name: "TeamMember",
        //                     component: () => import("@/views/team/member/"),
        //                     meta: {
        //                         name: i18n.t("menu.memberManagement"),
        //                         isEnterprise: true,
        //                     },
        //                 },
        //                 {
        //                     path: ":companyName/team/role",
        //                     name: "TeamRole",
        //                     component: () => import("@/views/team/member/role"),
        //                     meta: {
        //                         name: i18n.t("角色权限"),
        //                         isEnterprise: true,
        //                     },
        //                 },
        //             ],
        //         },
        //     ],
        // },
    ],
};
